import { Params, useSearchParams } from 'react-router-dom';
import { proStudioService, sendProStudioEvent } from '../xstate/app.xstate';

import { isProduction } from '@pypestream/utils';

let shouldSend = false;

export const syncXstateWithRouteParams = ({
  params,
  url: _url,
  debugMode = !isProduction,
}: {
  url: URL;
  params: Params<string>;
  debugMode?: boolean;
}) => {
  const {
    projectId: projectIdParam,
    botId: botIdParam,
    channelId: channelIdParam,
  } = params;

  const projectId = projectIdParam;
  const proStudioContext = proStudioService.getSnapshot().context;

  const {
    botName: botNameCtx,
    channelId: channelIdCtx,
    customerId: customerIdCtx,
    debugMode: debugModeCtx,
  } = {
    botName: proStudioContext.botName,
    channelId: proStudioContext.channelId,
    customerId: proStudioContext.customerId,
    debugMode: proStudioContext.debugMode,
  };

  const solutionId = proStudioContext.solutions?.find(
    (solution) => solution.id === botIdParam
  )?.name;

  const customerId = customerIdCtx;

  const eventPayload: {
    projectId?: string;
    botName?: string;
    channelId?: string;
    debugMode?: boolean;
    botIdURLParam?: string;
  } = {};

  eventPayload.botIdURLParam = solutionId || botIdParam;

  if (projectId && projectId !== proStudioContext.project?.id) {
    eventPayload.projectId = projectId;
    shouldSend = true;
  }

  if (debugMode !== proStudioContext.debugMode) {
    eventPayload.debugMode = debugMode;
    shouldSend = true;
  }

  if (solutionId && botNameCtx !== solutionId) {
    eventPayload.botName = solutionId;
    shouldSend = true;
  }

  if (
    projectId &&
    customerId &&
    botNameCtx &&
    channelIdParam &&
    channelIdCtx !== channelIdParam
  ) {
    eventPayload.channelId = channelIdParam;
    shouldSend = true;
  }

  if (shouldSend) {
    sendProStudioEvent({ type: 'setParams', payload: eventPayload });
    shouldSend = false;
  }
};
